export default __webpack_public_path__ + "static/media/J720_Home.3a6396b2.png";